<template>
    <div style="position: relative">
        <vue-echarts id="radiusChart" :option="option" ref="chart" class="chart2" autoResize />
    </div>
</template>

<script>
import { VueEcharts } from "vue3-echarts";
// import { computed, onMounted } from 'vue';

export default {
    name: 'radiusPolar',
    props: {
        SumDimProblem: Object
    },
    methods: {
        globalNumDecFixed(num, dec_amount) {
            var new_num = Number(num);
            if (!(num % 1)) {
                dec_amount = 0;
            }
            return new Intl.NumberFormat("en-US", {
                minimumFractionDigits: dec_amount,
            }).format(new_num.toFixed(dec_amount));
        }
    },
    mounted() {
        setTimeout(function () {
            this.$nextTick(() => {
                this.$refs.chart.setOption(this.option);
            })
        }.bind(this), 300)
    },
    components: {
        VueEcharts,
    },
    computed: {
        option() {
            return {
                textStyle: {
                    fontFamily: 'kanit',
                    fontWeight: '400'
                },
                angleAxis: {
                    type: 'category',
                    data: ['ที่อยู่อาศัย',
                        'สุขภาพ',
                        'การศึกษา',
                        'มีงานทำ/รายได้',
                        'ครอบครัว',
                        'ความรุนแรง',
                        'ค้ามนุษย์',
                        'การเข้าถึงสิทธิ',
                        'อื่นๆ'],
                    startAngle: 110,
                    axisLine: {
                        show: false
                    },
                    axisTick: { show: false },
                },
                radiusAxis: {
                    max: this.SumDimProblem.total_survey, show: false,
                    axisLine: {
                        show: false
                    },
                    axisTick: { show: false },
                },
                polar: {
                    radius: [0, '80%']
                },
                tooltip: {
                    confine: 'true',
                    axisPointer: {
                        label: {
                            show: false
                        }
                    },
                    textStyle: {
                        fontFamily: 'kanit',
                        fontWeight: '400',
                        color: '#1d4481'
                    },
                    backgroundColor: '#f3f6f9',
                    borderColor: 'none'
                },
                series: [
                    {
                        type: 'bar',
                        data: [{
                            value: this.SumDimProblem.total_survey - this.SumDimProblem.prob_housing,
                            itemStyle: { color: '#49c8ad', borderColor: 'grey', borderWidth: .3 },
                            tooltip: {
                                formatter: "<b>ที่อยู่อาศัย</b><br/>" + this.globalNumDecFixed(this.SumDimProblem.prob_housing, 0) + " คน"
                            }
                        }, {
                            value: this.SumDimProblem.total_survey - this.SumDimProblem.prob_health,
                            itemStyle: { color: '#ff7f74', borderColor: 'grey', borderWidth: .3 },
                            tooltip: {
                                formatter: "<b>สุขภาพ</b><br/>" + this.globalNumDecFixed(this.SumDimProblem.prob_health, 0) + " คน"
                            }
                        }, {
                            value: this.SumDimProblem.total_survey - this.SumDimProblem.prob_education,
                            itemStyle: { color: '#50c4fe', borderColor: 'grey', borderWidth: .3 },
                            tooltip: {
                                formatter: "<b>การศึกษา</b><br/>" + this.globalNumDecFixed(this.SumDimProblem.prob_education, 0) + " คน"
                            }
                        }, {
                            value: this.SumDimProblem.total_survey - this.SumDimProblem.prob_occupation,
                            itemStyle: { color: '#fdcc4e', borderColor: 'grey', borderWidth: .3 },
                            tooltip: {
                                formatter: "<b>มีงานทำ/รายได้</b><br/>" + this.globalNumDecFixed(this.SumDimProblem.prob_occupation, 0) + " คน"
                            }
                        }, {
                            value: this.SumDimProblem.total_survey - this.SumDimProblem.prob_family,
                            itemStyle: { color: '#ff81f0', borderColor: 'grey', borderWidth: .3 },
                            tooltip: {
                                formatter: "<b>ครอบครัว</b><br/>" + this.globalNumDecFixed(this.SumDimProblem.prob_family, 0) + " คน"
                            }
                        }, {
                            value: this.SumDimProblem.total_survey - this.SumDimProblem.prob_violence,
                            itemStyle: { color: '#bbce3f', borderColor: 'grey', borderWidth: .3 },
                            tooltip: {
                                formatter: "<b>ความรุนแรง</b><br/>" + this.globalNumDecFixed(this.SumDimProblem.prob_violence, 0) + " คน"
                            }
                        }, {
                            value: this.SumDimProblem.total_survey - this.SumDimProblem.prob_human_trafficking,
                            itemStyle: { color: '#9b88e3', borderColor: 'grey', borderWidth: .3 },
                            tooltip: {
                                formatter: "<b>ค้ามนุษย์</b><br/>" + this.globalNumDecFixed(this.SumDimProblem.prob_human_trafficking, 0) + " คน"
                            }
                        }, {
                            value: this.SumDimProblem.total_survey - this.SumDimProblem.prob_accessibility,
                            itemStyle: { color: '#DC955A', borderColor: 'grey', borderWidth: .3 },
                            tooltip: {
                                formatter: "<b>การเข้าถึงสิทธิ</b><br/>" + this.globalNumDecFixed(this.SumDimProblem.prob_accessibility, 0) + " คน"
                            }
                        }, {
                            value: this.SumDimProblem.total_survey - this.SumDimProblem.prob_others,
                            itemStyle: { color: '#9fb9b0', borderColor: 'grey', borderWidth: .3 },
                            tooltip: {
                                formatter: "<b>อื่นๆ</b><br/>" + this.globalNumDecFixed(this.SumDimProblem.prob_others, 0) + " คน"
                            }
                        }],
                        center: ['70%', '50%'],
                        coordinateSystem: 'polar',
                        name: {
                            show: false
                        },
                        stack: 'a',
                        label: {
                            show: false,
                        },
                        emphasis: {
                            focus: 'self'
                        }
                    },
                    {
                        type: 'bar',
                        data: [{
                            value: this.SumDimProblem.prob_housing,
                            itemStyle: { color: 'white', borderColor: 'grey', borderWidth: .3 }
                        }, {
                            value: this.SumDimProblem.prob_health,
                            itemStyle: { color: 'white', borderColor: 'grey', borderWidth: .3 }
                        }, {
                            value: this.SumDimProblem.prob_education,
                            itemStyle: { color: 'white', borderColor: 'grey', borderWidth: .3 }
                        }, {
                            value: this.SumDimProblem.prob_occupation,
                            itemStyle: { color: 'white', borderColor: 'grey', borderWidth: .3 }
                        }, {
                            value: this.SumDimProblem.prob_family,
                            itemStyle: { color: 'white', borderColor: 'grey', borderWidth: .3 }
                        }, {
                            value: this.SumDimProblem.prob_violence,
                            itemStyle: { color: 'white', borderColor: 'grey', borderWidth: .3 }
                        }, {
                            value: this.SumDimProblem.prob_human_trafficking,
                            itemStyle: { color: 'white', borderColor: 'grey', borderWidth: .3 }
                        }, {
                            value: this.SumDimProblem.prob_accessibility,
                            itemStyle: { color: 'white', borderColor: 'grey', borderWidth: .3 }
                        }, {
                            value: this.SumDimProblem.prob_others,
                            itemStyle: { color: 'white', borderColor: 'grey', borderWidth: .3 }
                        }],
                        coordinateSystem: 'polar',
                        center: ['70%', '50%'],
                        name: ' ',
                        stack: 'a',
                        emphasis: {
                            focus: 'none'
                        },
                        tooltip: {
                            title: {
                                show: false
                            },
                            show: false
                        }
                    },
                ],
                legend: {
                    show: false,
                },
                animation: true
            }
        }
    }
};
</script>

<style scoped>
.chart2 {
    max-height: 400px;
    height: 400px;
}

@media screen and (max-width: 991.8px) {
    .chart2 {
        max-height: 300px
    }
}
</style>